import React, { FunctionComponent, ReactNode, useMemo } from 'react';
import DataRecordTable, { CellTypeEnum } from 'src/libraries/data-record-table';
import Translate from 'ui/atoms/translate';
import {
  AdminApi,
  AdminListingsListOrderingEnum,
  AdminListingsValuesRetrieveFieldEnum,
  AdminProductDistributionPlatformListing,
} from 'api';
import WithDataRecord from 'src/hoc/WithDataRecord';
import { PaginationProps } from 'ui/molecules/pagination';
import useApiCall from 'src/hooks/use-api-call';

export interface ListingsTableProps {
  productId: string;
  title?: ReactNode;
  loading?: boolean;
  paginationProps?: PaginationProps;
  defaultLimit?: number;
  forceDataLoad?: boolean;
  skipFilterUrlSync?: boolean;
}

const ListingsTable: FunctionComponent<ListingsTableProps> = WithDataRecord<
  AdminApi,
  AdminProductDistributionPlatformListing
>(AdminApi)(
  ({ data, title, loading, paginationProps, onOrderBy, ordering, productId }) => {
    const { makeAuthenticatedApi } = useApiCall();
    const adminApi: AdminApi = useMemo(() => makeAuthenticatedApi(AdminApi), [makeAuthenticatedApi]);

    return (
      <DataRecordTable
        onOrderBy={onOrderBy}
        ordering={ordering}
        data={data as AdminProductDistributionPlatformListing[]}
        title={title}
        loading={loading}
        paginationProps={paginationProps}
        cells={[
          {
            title: <Translate name="listings.distributionPlatform" />,
            render: (platform) => platform.distributionPlatformDisplayName,
            orderingFieldName: AdminListingsListOrderingEnum.DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC,
            type: CellTypeEnum.text,
            filterName: 'distributionPlatformDisplayName',
            searchFieldName: AdminListingsValuesRetrieveFieldEnum.DISTRIBUTION_PLATFORM_DISPLAY_NAME,
            getFilterData: (params: any) => adminApi.adminListingsValuesRetrieve({ ...params, productId: [productId] }),
          },
        ]}
      />
    );
  },
  (api, props, offset, limit, ordering) => {
    return api.adminListingsList({
      offset,
      limit,
      ordering: ordering as AdminListingsListOrderingEnum,
      ...props,
      productId: [props.productId],
    });
  },
);

export default ListingsTable;
